import { Component, OnInit, Input, Output, EventEmitter, ViewChildren } from '@angular/core';
import { Utilities } from '../../utils/utilities.class';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'dum-table-aux',
  templateUrl: './table-aux.component.html',
  styleUrls: ['./table-aux.component.scss']
})
export class TableAuxComponent implements OnInit {

  @ViewChildren('formTable') formTable: NgForm;

  /**
   *
   * Columnas que contendrá la tabla
   * @memberof TableAuxComponent
   */
  @Input() cols;

  /**
   *
   * Columnas que contendrá la modal
   * @memberof TableAuxComponent
   */
  @Input() colsDialog;

  /**
   *
   * Valores que contendrá la tabla
   * @type {any[]}
   * @memberof TableAuxComponent
   */
  @Input() values: any[] = [];

  /**
   *
   *
   * @type {string}
   * @memberof TableAuxComponent
   */
  @Input() editMode: string;

  /**
   *
   *
   * @type {string}
   * @memberof TableAuxComponent
   */
  @Input() datakey: string;

  /**
   *
   * Propiedad que indica el número total de elementos que tiene la tabla( se usa con la opción lazy)
   * @type {number}
   * @memberof TableAuxComponent
   */
  @Input() totalRecords: number;

  /**
   *
   * Propiedad que indica si se está cargando datos en el momento
   * @type {boolean}
   * @memberof TableAuxComponent
   */
  @Input() loading: boolean;

  /**
   *
   * Propiedad que indica si la tabla tendrá paginación  o no
   * @type {boolean}
   * @memberof TableAuxComponent
   */
  @Input() paginator: boolean = true;

  /**
   *
   * Propiedad que indica el numero maximo de filas que tendrá una pagina.
   * @type {number}
   * @memberof TableAuxComponent
   */
  @Input() rows: number = 10;

  /**
   *
   * Propiedad que indica si la tabla será Lazy o no.
   * @type {boolean}
   * @memberof TableAuxComponent
   */
  @Input() lazy: boolean = false;

  /**
   *
   * Apartado/sección a la que pertenece la tabla.
   * @type {string}
   * @memberof TableAuxComponent
   */
  @Input() section: string;

  /**
   *
   *
   * @type {string[]}
   * @memberof TableAuxComponent
   */
  @Input() globalFilterFields: string[];

  /**
   *
   *
   * @type {string}
   * @memberof TableAuxComponent
   */
  @Input() msgSinRegistros: string = this.translateService.instant('GLOBAL.NO.RESULTADOS.BUSQUEDA');

  /**
   *
   *
   * @type {boolean}
   * @memberof TableAuxComponent
   */
  @Input() editDeleteOnly: boolean = false;

  /**
   *
   *
   * @type {boolean}
   * @memberof TableAuxComponent
   */
  @Input() responsive: boolean = true;

  @Input() cerrarSesion: boolean = false;

  @Input() showOnly: boolean = false;

  /**
   *
   *  Evento que se emite al pulsar sobre editar una fila( no se edita en la propia tabla)
   * @type {EventEmitter<number>}
   * @memberof TableAuxComponent
   */
  @Output() eventToEdit: EventEmitter<number> = new EventEmitter<number>();

  /**
   *
   *  Evento que se emite al eliminar una fila
   * @type {EventEmitter<any>}
   * @memberof TableAuxComponent
   */
  @Output() eventDelete: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventSave: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventAddNew: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventLazyLoading: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventFilter: EventEmitter<string[]> = new EventEmitter<string[]>();

  @Output() eventCloseSession: EventEmitter<any> = new EventEmitter<any>();

  @Output() eventShow: EventEmitter<any> = new EventEmitter<any>();

  cloneRows: any[] = [];
  visibleNewRow: boolean;
  newRow: any = {};
  headerDialogNew: string;
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  /**
   *
   * Función que emite toEdit
   * @param {number} id
   * @memberof TableAuxComponent
   */
  goToEdit(id: number) {
    this.eventToEdit.emit(id);
  }

  /**
   *
   * funcion que emite eventDelete
   * @param {*} row
   * @memberof TableAuxComponent
   */
  delete(row) {
    this.eventDelete.emit(row);
  }

  onRowEditInit(row) {
    this.cloneRows[row.id] = Utilities.objectClone(row) as any;
  }
  onRowEditSave(row, index: number) {
   const editSaveConfirm = (result) => {
      if (!result) {
        this.values[index] = this.cloneRows[row.id];
      }

   };
   this.eventSave.emit({row, editSaveConfirm });
  }

  onRowEditCancel(row, index: number) {
    this.values[index] = this.cloneRows[row.id];
}

new(){

  this.headerDialogNew = `${this.section}, Nuevo registro `;
  this.visibleNewRow = true;
}

addNew() {
  const cloneNewRow = Utilities.objectClone(this.newRow) as any;
  this.eventAddNew.emit(cloneNewRow);
  this.newRow = {};
  this.visibleNewRow = false;
  if (!this.lazy) {
    this.values.push(cloneNewRow);
  }
}

cancelAddNew() {
  this.newRow = {};
  this.visibleNewRow = false;
}

lazyLoading(event) {
  this.eventLazyLoading.emit(event);
}

filter(valor, type) {
  this.eventFilter.emit([valor, type]);
}

closeSession(row: any) {
  this.eventCloseSession.emit(row);
}
goToShow(row) {
  this.eventShow.emit(row);
}
}
